import Sqids from "sqids";
import { convert } from "url-slug";

import { validateSqid } from "./sqids";

const sqids = new Sqids({
  minLength: 5,
});

export const slugify = ({ id, name }: { id: number; name: string }) => {
  const slug = convert(name);
  const sqid = sqids.encode([id]);
  return `${slug}-${sqid}`;
};

export const deslugify = (slug: string) => {
  const sqid = slug.split("-").pop();

  if (!sqid) {
    return null;
  }

  return validateSqid(sqids, sqid);
};
